/**
 * React Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles/globals.css';
import { useThemeStore } from './stores/themeStore.js';

// Initialise theme before first render to avoid flash of wrong theme
useThemeStore.getState().init();

// Unregister any existing service workers from previous PWA setup
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
);
